import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { PlanType } from "sdk/types";
import { CouponInfo } from "./CouponInfo";
import { Values } from "./types";

interface Props {
  type: PlanType;
}

export const CouponInfoSection: FC<Props> = ({ type }) => {
  const {
    values: { coupon, promoCode },
  } = useFormikContext<Values>();

  return (
    <>
      {coupon && (
        <Flex direction="column" w="100%">
          <CouponInfo code={promoCode} coupon={coupon} type={type} />
        </Flex>
      )}
    </>
  );
};
